module.exports = __webpack_public_path__ + "img/testflight.15c4a8a6.webp";